export enum Integration_Types {
  PAYMENT_GATEWAY = 'payment_gateway',
  PAYMENT = 'payment', // Tipo simplificado del servidor
  SHIPPING = 'shipping',
  INVENTORY = 'inventory',
  ACCOUNTING = 'accounting',
  CRM = 'crm',
  EMAIL = 'email',
  SMS = 'sms',
  SOCIAL_MEDIA = 'social_media',
  ANALYTICS = 'analytics',
  WEBHOOK = 'webhook'
}

export interface IntegrationConfiguration {
  // URLs de configuración
  apiUrl?: string;
  webhookUrl?: string;
  callbackUrl?: string;
  
  // Credenciales
  apiKey?: string;
  apiSecret?: string;
  clientId?: string;
  clientSecret?: string;
  token?: string;
  refreshToken?: string;
  
  // Configuración específica
  environment?: 'sandbox' | 'production' | 'test';
  version?: string;
  timeout?: number;
  retryAttempts?: number;
  
  // Configuración adicional dinámica
  [key: string]: any;
}

export interface Integration {
  id?: number;
  name: string;
  type: Integration_Types;
  description?: string | null;
  
  // URLs y endpoints
  apiUrl?: string;
  webhookUrl?: string;
  documentationUrl?: string;
  
  // Credenciales básicas
  token?: string | null;
  apiKey?: string;
  publicKey?: string | null; // Campo del servidor
  
  // Configuración avanzada
  configuration?: IntegrationConfiguration;
  
  // Estado y metadata
  isActive?: boolean;
  isSystem?: boolean; // Integraciones del sistema vs personalizadas
  provider?: string; // Proveedor (ej: "MercadoPago", "Stripe", etc.)
  logoUrl?: string;
  urlLogo?: string; // Alias para logoUrl - compatibilidad
  
  // Configuración de rate limiting
  rateLimitPerMinute?: number;
  rateLimitPerHour?: number;
  
  // Configuración de timeout
  timeoutSeconds?: number;
  
  // Tags y categorización
  tags?: string[];
  category?: string;
  
  // Información adicional
  supportUrl?: string;
  supportEmail?: string;
  notes?: string;
  
  // Auditoría (campos del servidor)
  createdAt?: string;
  updatedAt?: string;
  deletedAt?: string | null;
  createdBy?: number;
  updatedBy?: number;
}

export interface CreateIntegrationDto {
  name: string;
  type: Integration_Types;
  description?: string;
  
  // URLs
  apiUrl?: string;
  webhookUrl?: string;
  documentationUrl?: string;
  
  // Credenciales
  token?: string;
  apiKey?: string;
  publicKey?: string;
  configuration?: IntegrationConfiguration;
  
  // Metadata
  provider?: string;
  logoUrl?: string;
  urlLogo?: string; // Alias para logoUrl
  isActive?: boolean;
  
  // Configuración técnica
  rateLimitPerMinute?: number;
  rateLimitPerHour?: number;
  timeoutSeconds?: number;
  
  // Categorización
  tags?: string[];
  category?: string;
  
  // Soporte
  supportUrl?: string;
  supportEmail?: string;
  notes?: string;
}

export interface UpdateIntegrationDto {
  name?: string;
  type?: Integration_Types;
  description?: string;
  
  // URLs
  apiUrl?: string;
  webhookUrl?: string;
  documentationUrl?: string;
  
  // Credenciales
  token?: string;
  apiKey?: string;
  publicKey?: string;
  configuration?: IntegrationConfiguration;
  
  // Metadata
  provider?: string;
  logoUrl?: string;
  urlLogo?: string; // Alias para logoUrl
  isActive?: boolean;
  
  // Configuración técnica
  rateLimitPerMinute?: number;
  rateLimitPerHour?: number;
  timeoutSeconds?: number;
  
  // Categorización
  tags?: string[];
  category?: string;
  
  // Soporte
  supportUrl?: string;
  supportEmail?: string;
  notes?: string;
}

export interface StoreIntegration {
  id: number;
  storeId: number;
  integrationId: number;
  isEnabled: boolean;
  integration?: Integration;
}